import React, { useState, useEffect } from "react";
import "./card.css";
import addcardicon from "../../../../../Assets/addnewbank.svg";
import plusicon from "../../../../../Assets/plus.svg";
import mastercard from "../../../../../Assets/mastercard.svg";
import visacard from "../../../../../Assets/visa.svg";
import vervecard from "../../../../../Assets/Verve.svg";

import { useUser } from "../../../../../../hooks/use-user";
import { Util } from "../../../../../../helpers/util";
import { FWPUBK } from "../../../../../../helpers/config";
import { $api } from "../../../../../../helpers/$api";
import { toast } from "react-toastify";

const AddNewBankCard = ({ setStage, stageEmit }) => {
  const { currency } = Util.getCurrency();
  const [amount] = stageEmit;
  const user = useUser();
  // const [cardType, setCardType] = useState(0);
  const [userCards, setUserCards] = useState([]);
  const [isBusy, setBusy] = useState(false);

  const handleCardClick = async (card_id) => {
    try {
      if (!isBusy) {
        setBusy(true);
        toast.info("initiating charge on card");
        await $api.user.chargeSavedCard({ card_id, amount });
        toast.success("card successfully charged");
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      setBusy(false);
      toast.error(`error charging card - ${error.message}`);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const userCards = await $api.user.getUserCards();

        setUserCards(userCards);
      } catch (error) {
        // error getting cards
      }
    })();
  }, [setUserCards]);

  const handleCardAdd = () => {
    // eslint-disable-next-line no-undef
    FlutterwaveCheckout({
      public_key: FWPUBK,
      tx_ref: `tx_ref-${Util.generateRandomString(5)}`,
      amount,
      ...Util.getFlutterCurrencyAndCountryFromUserCountry(user.country),
      payment_options: "card",
      customer: {
        email: user.email,
        phone_number: user.phone,
        name: `${user.firstname} ${user.lastname}`,
      },
      callback: async function (data) {
        // call verification endpoint here
        try {
          await $api.user.verifyCardTransaction(data.transaction_id);
        } catch (error) {
          console.log(error.message);
        }

        console.log(JSON.stringify(data, null, 2));
      },
      customizations: {
        title: "OVest",
        description: "Add new card",
        logo: "https://myovest.com//img/logo.png",
      },
    });
  };

  return (
    <div className="addnewcard">
      <div
        className=""
        style={{
          marginTop: "40px",
          marginBottom: "23px",
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div className="addnewcard-header">
          <h5>By Card</h5>
          <p>Fund your OVest wallet with your debit card.</p>
        </div>
        <div className="addnewcard-body">
          <p>
            Amount:
            <span>
              {" "}
              {currency}
              {amount}
            </span>
          </p>

          {userCards.map((card) => {
            return (
              <div
                key={card.id}
                className="addnewcard-card"
                onClick={handleCardClick}
              >
                <img
                  src={
                    card.card[0] === "5"
                      ? mastercard
                      : card.card[0] === "4"
                      ? visacard
                      : card.card.length === 18
                      ? vervecard
                      : ""
                  }
                  alt="card-type-img"
                />

                <p>
                  {card.firstname} {card.lastname} <br /> {card.card}
                  {console.log(typeof card.card[0])}
                </p>
              </div>
            );
          })}

          <div
            className="addcard"
            onClick={handleCardAdd}
            disabled={isBusy}
            style={{
              cursor: "pointer",
            }}
          >
            <img
              className="addcardicon"
              src={addcardicon}
              alt="add card icon"
            />
            <p>Add a new bank card</p>
            <img className="plus" src={plusicon} alt=" plus icon" />
          </div>
        </div>
        {/* <StyledBankTransferFormButton
          type="submit"
          style={{ marginTop: "100px" }}
        >
          Confirm
        </StyledBankTransferFormButton> */}
      </div>
    </div>
  );
};

export default AddNewBankCard;
